import type { PropsWithChildren } from "react";
import { GraphemePanelsMnemonicsTabContext } from "#grapheme-panels-mnemonics-tab-context";
import {
  useGraphemePanelsMnemonicsTabContextValue,
  type GraphemePanelsMnemonicsTab,
} from "#grapheme-panels-mnemonics-tab-context-value";

export function GraphemePanelsMnemonicsTabContextProvider({
  activeIndex,
  children,
  morpheme,
  navigate,
  routeNames,
  tabButtonList,
}: PropsWithChildren<{
  activeIndex: number;
  morpheme: string;
  navigate: (routeName: string) => void;
  routeNames: readonly string[];
  tabButtonList: readonly GraphemePanelsMnemonicsTab[];
}>) {
  const value = useGraphemePanelsMnemonicsTabContextValue({
    activeIndex,
    morpheme,
    navigate,
    routeNames,
    tabButtonList,
  });
  return (
    <GraphemePanelsMnemonicsTabContext.Provider value={value}>
      {children}
    </GraphemePanelsMnemonicsTabContext.Provider>
  );
}
